// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lylm","content":"styles_content__3XXEb"};